<template>
    <div class="tbl-contents-container">
        <fieldset class="field-style">
            <legend>table filters</legend>
            <div class="search-bar">
                <input type="search"
                    :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH_TEXT')"
                    v-model="searchTxt"
                    @keyup="debounceSearchText">
                <i class="icon"></i>
                <button class="buttons-icon" 
                    data-type="ghost" 
                    data-size="s" 
                    data-icon="clear"
                    @click="callSetSearchText('')"
                >Reset</button>
            </div>
            <p class="tbl-message">
                {{$t('COMPLIANCE.LABEL.EA_SELECTED', {'cnt': checkedWtlList.length})}}
            </p>
            <table class="tbl-default" data-scrollable>
                <colgroup>
                    <col>
                    <col>
                    <col>
                    <col>
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col" colspan="2" class="txt-c" data-size="name">
                            <label>{{ $t('COMPLIANCE.WHITELIST.HEADER.NAME')}}</label>
                        </th>
                        <th scope="col" class="txt-c" data-size="resource">
                            <label>{{ $t('COMPLIANCE.WHITELIST.HEADER.RESOURCE')}}<!--리소스--></label>
                        </th>
                        <th scope="col" class="txt-c">
                            <label>{{ $t('COMPLIANCE.WHITELIST.HEADER.LAST_UPDATED')}}<!--마지막 업데이트--></label>                            
                        </th>
                        <th scope="col" class="txt-c">
                            <label>{{ $t('COMPLIANCE.WHITELIST.HEADER.UPDATED_USER')}}<!--업데이트 사용자--></label>
                        </th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="(aWtl, idx) in allWtlList" :key="idx">
                    <td class="txt-c" data-size="checkbox">
                        <input type="checkbox" class="custom-wl-cb"
                            :id="aWtl.wtlId"
                            :value="aWtl.wtlId"
                            v-model="checkedWtlList">
                    </td>
                    <td data-size="name">
                        {{aWtl.titl}}
                    </td>
                    <td data-size="resource">
                        {{aWtl.rsrcCnt}}
                    </td>
                    <td class="txt-c">
                        <time datetime="">{{ aWtl.updtDt ? convertUtcTimezoneToLocal(aWtl.updtDt) : ''}}</time>
                    </td>
                    <td>
                        {{aWtl.updtUserNm}}
                    </td>
                </tr>
                </tbody>
            </table>
        </fieldset>
    </div>
</template>
<script>
export default {
    name: "AddToWhiteListForm",
    data() {
        return {
            searchTxt: "",
            checkedWtlList: [],
            originAppliedWL: [],
        }
    },
    props: {
        allWtlList: Array,
        checkWtlList: {
            type: Array,
            default: ()=>{return []}
        },
        callSetSearchText: {
            type: Function,
            default: ()=>{}
        },
        callSetCheckedWhiteList: {
            type: Function,
            default: ()=>{}
        }
    },
    created: function() {
        this.debounceSearchText = _.debounce(this.searchText, 1000);
    },
    mounted() {
        this.checkedWtlList = this.checkWtlList;
        this.originAppliedWL = this.checkWtlList || [];
    },
    watch: {
        checkedWtlList(newVal, olv) {
            const diffBinA = _.difference(newVal,this.originAppliedWL);
            const diffAinB = _.difference(this.originAppliedWL,newVal);
            const isDisable = (diffAinB.length == 0 && diffBinA.length == 0);
            this.callSetCheckedWhiteList(newVal, isDisable);
        }
    },
    methods: {
        changeWhiteList() {
            console.log(this.checkedWtlList);
        },
        searchText() {
            this.callSetSearchText(this.searchTxt);
        },
        convertUtcTimezoneToLocal: function(date) {
            return this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale);
        },
    }
}
</script>
<style scoped>
.custom-wl-cb {
    position: relative;
    height: 15px;
    width: 15px;
    vertical-align: middle;
    border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/compliance/components/AddToWhiteListForm.vue